import { render, staticRenderFns } from "./ProfileProgress.vue?vue&type=template&id=1b7006a6&"
import script from "./ProfileProgress.vue?vue&type=script&lang=js&"
export * from "./ProfileProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProgressCircle: require('/home/forge/portal.gradlinc.co.za/releases/20260824084656/components/global/progress-bars/ProgressCircle.vue').default})
